var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { iframePageState } from '../../app.constants';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { UserService } from '../../services/user.service';
var AdminComponent = /** @class */ (function (_super) {
    __extends(AdminComponent, _super);
    function AdminComponent(userService) {
        var _this = _super.call(this, userService) || this;
        _this.userService = userService;
        return _this;
    }
    AdminComponent.prototype.companyChangeCallback = function (companyId) {
        // callback when switching account
    };
    AdminComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.route = iframePageState.admin;
    };
    return AdminComponent;
}(AbstractAchooComponent));
export { AdminComponent };



// WEBPACK FOOTER //
// ./src/app/main/admin/admin.component.ts.pre-build-optimizer.js